import React, { Component } from 'react';

class FullPageLoader extends Component {

    constructor(){
        super()
    }
    
    componentDidMount(){
       //  
    }

    componentWillUnmount(){
       //  
        // remove set time out later
        setTimeout(function() {
            document.querySelector(".loader-wrapper").style.display= "none";
        }, 1000);
    }

    render() {
        return (
            <div className="loader-wrapper">
                <div className="loader"></div>
            </div>
        )
    }
}

export default FullPageLoader;